import React, { useState, useEffect } from "react";
import {
  Layout,
  Input,
  Button,
  Collapse,
  Tag,
  Select,
  InputNumber,
} from "antd";
import "./index.scss";
import _ from "lodash"; // 引入lodash来使用_.debounce
import axiosInstance from "@/axios/axiosInstance";
import { DownCircleTwoTone, UpCircleTwoTone } from "@ant-design/icons";
import tool from "@/assets/tool";
const { Header, Content, Footer } = Layout;

const HashrateManagement = () => {
  // 控制展开/收起状态，使用面板的key作为activeKey
  const [activeKey, setActiveKey] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [shiyong, setnShiyong] = useState("");
  const [area, setArea] = useState();
  const [xianc, setnXc] = useState({ key: "0", value: "全部" });
  const [xtTag, setnXtTag] = useState("0");
  const [ccTag, setnCcTag] = useState({ key: "0", value: "全部" });
  const [cpuTag, setcpuTag] = useState("全部");
  const [ncTag, setncTag] = useState("全部");
  const [kdTag, setkdTag] = useState({ key: "0", value: "全部" });
  const [computeData, setComputeData] = useState([]);
  const [priceRange, setPriceRange] = useState({
    minPrice: null,
    maxPrice: null,
  });
  const extractRange = (rangeString) => {
    if (!rangeString || !rangeString.includes("-")) {
      return { min: "", max: "" };
    }

    const [min, max] = rangeString.split("-").map(Number);
    return { min, max };
  };

  const getCompute = async () => {
    const params = new URLSearchParams();

    // if (a) params.append("systemEnvironment", a);
    if (shiyong) params.append("useScene", shiyong);
    if (area) params.append("area", area);
    if (xtTag && xtTag != "0") params.append("systemEnvironment", xtTag);

    const xiancRange = extractRange(xianc.value);
    if (xiancRange.min !== "" && xiancRange.max !== "") {
      params.append("startGraphicsMemory", xiancRange.min);
      params.append("endGraphicsMemory", xiancRange.max);
    }

    const ccTagRange = extractRange(ccTag.value);
    if (ccTagRange.min !== "" && ccTagRange.max !== "") {
      params.append("startSpace", ccTagRange.min);
      params.append("endSpace", ccTagRange.max);
    }

    if (cpuTag !== "全部") params.append("cpu", cpuTag);
    if (ncTag !== "全部") params.append("memory", ncTag);

    const kdTagRange = extractRange(kdTag.value);
    if (kdTagRange.min !== "" && kdTagRange.max !== "") {
      params.append("startWidth", kdTagRange.min);
      params.append("endWidth", kdTagRange.max);
    }

    try {
      const response = await axiosInstance.get(
        `computPower/page/list?${params.toString()}&page=1&limit=100`
      );
      setComputeData(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    getCompute();
    document.title =
      "渐风AI,GPU算力交易,智算共享,AI算力在线交易,GPU出租,显卡租赁,大模型部署算力,AI训练资源,AI推理资源,算力在线交易";
  }, [shiyong, area, xtTag, xianc, ccTag, cpuTag, kdTag, ncTag]); // 空依赖项数组表示这个 effect 只在组件挂载时运行
  // 处理价格区间的变化
  const handlePriceChange = (type, value) => {
    setPriceRange((prevState) => ({
      ...prevState,
      [type]: value,
    }));
  };

  // 搜索函数（这里只是打印了价格区间，实际中可能是发送请求）
  const search = () => {
    if (priceRange.minPrice !== null && priceRange.maxPrice !== null) {
      console.log(
        `搜索价格区间: ${priceRange.minPrice} 到 ${priceRange.maxPrice}`
      );
      // 在这里发送搜索请求或执行其他操作
    } else {
      console.log("请输入完整的价格区间！");
    }
  };
  const handleShiClick = (tag) => {
    if (shiyong !== tag.key) {
      setnShiyong(tag.key);
    }
  };
  const handleXcClick = (tag) => {
    if (xianc.key !== tag.key) {
      setnXc(tag);
    }
  };
  /**
   * 处理点击事件，用于更新选中的标签。
   * @param {Object} tag - 点击的标签对象，包含 key 属性。
   * @returns {void}
   * @description 当点击的标签与当前选中的标签不同时，更新选中的标签。
   */
  const handleXthjClick = (tag) => {
    if (xtTag !== tag.key) {
      setnXtTag(tag.key);
    }
  };
  const handleCcTagClick = (tag) => {
    if (ccTag.key !== tag.key) {
      setnCcTag(tag);
    }
  };

  const handleTagClick = (tag) => {
    if (cpuTag !== tag.value) {
      setcpuTag(tag.value);
    }
  };
  const handleTNeicClick = (tag) => {
    if (ncTag !== tag.value) {
      setncTag(tag.value);
    }
  };
  const handleKdClick = (tag) => {
    if (kdTag.key !== tag.key) {
      setkdTag(tag);
    }
  };

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const toggle = () => {
    // 如果当前是展开的，则收起；如果是收起的，则展开
    setActiveKey((prevActiveKey) => (prevActiveKey.length ? [] : ["1"]));
  };
  const neitagOptions = [
    { key: 0, value: "全部" },
    { key: "1", value: "AI绘图" },
    { key: "2", value: "科学计算 " },
    { key: "3", value: "模型渲染" },
    { key: "4", value: "模型推理" },
    { key: "5", value: "模型训练" },
  ].map((tag) => (
    <Tag
      color={shiyong == tag.key ? "blue" : "default"}
      key={tag.value}
      onClick={() => handleShiClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const cputagOptions = [
    { key: "0", value: "全部" },
    { key: "1", value: "1", id: "12" },
    { key: "2", value: "2 ", id: "121" },
    { key: "3", value: "4", id: "122" },
    { key: "4", value: "8", id: "123" },
    { key: "5", value: "16", id: "124" },
    { key: "6", value: "32", id: "125" },
    { key: "7", value: "48", id: "1225" },
  ].map((tag) => (
    <Tag
      color={cpuTag == tag.value ? "blue" : "default"}
      key={tag.id}
      onClick={() => handleTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const cpus = [
    { key: 1, value: "1核(vCPU)" },
    { key: 2, value: "2核(vCPU) " },
    { key: 3, value: "4核(vCPU)" },
    { key: 4, value: "8核(vCPU)" },
    { key: 5, value: "16核(vCPU)" },
    { key: 6, value: "32核(vCPU)" },
    { key: 7, value: "48核(vCPU)" },
  ];
  const neics = [
    { key: 1, value: "2GiB" },
    { key: 2, value: "4GiB " },
    { key: 3, value: "8GiB" },
    { key: 4, value: "16GiB" },
    { key: 5, value: "32GiB" },
    { key: 6, value: "64GiB" },
    { key: 7, value: "128GiB" },
    { key: 8, value: "256GiB" },
    { key: 9, value: "512GiB" },
  ];
  const xctagOptions = [
    { key: "0", value: "全部" },
    { key: "1", value: "4-8" },
    { key: "2", value: "10-20" },
    { key: "3", value: "20-40" },
    { key: "4", value: "40-100" },
    { key: "5", value: "100以上" },
  ].map((tag) => (
    <Tag
      color={xianc.key === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleXcClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const xttagOptions = [
    { key: "0", value: "全部" },
    { key: "1", value: "Windows" },
    { key: "2", value: "Linux" },
    { key: "3", value: "Ubuntu" },
    { key: "4", value: "CentOS" },
  ].map((tag) => (
    <Tag
      color={xtTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleXthjClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const cctagOptions = [
    { key: "0", value: "全部" },
    { key: "1", value: "40-100", id: "12" },
    { key: "2", value: "100-200", id: "13" },
    { key: "3", value: "200-500", id: "14" },
    { key: "4", value: "500-2000", id: "15" },
    { key: "4", value: "2000以上", id: "16" },
  ].map((tag) => (
    <Tag
      color={ccTag.key === tag.key ? "blue" : "default"}
      key={tag.id}
      onClick={() => handleCcTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const neictagOptions = [
    { key: "0", value: "全部" },
    { key: "1", value: "2" },
    { key: "2", value: "4 " },
    { key: "3", value: "8" },
    { key: "4", value: "16" },
    { key: "5", value: "32" },
    { key: "6", value: "64" },
    { key: "7", value: "128" },
    { key: "8", value: "256" },
    { key: "9", value: "512" },
  ].map((tag) => (
    <Tag
      color={ncTag === tag.value ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTNeicClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const dktagOptions = [
    { key: "0", value: "全部" },
    { key: "1", value: "5-20" },
    { key: "2", value: "20-100 " },
    { key: "3", value: "100-500" },
    { key: "4", value: "500-1000" },
    { key: "5", value: "1000-2000" },
    { key: "6", value: "2000-5000" },
    { key: "7", value: "5000以上" },
  ].map((tag) => (
    <Tag
      color={kdTag.key === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleKdClick(tag)}
    >
      {tag.value}
    </Tag>
  ));

  const allProvinces = [
    { value: "北京市", label: "北京市" },
    { value: "天津市", label: "天津市" },
    { value: "上海市", label: "上海市" },
    { value: "重庆市", label: "重庆市" },
    { value: "河北省", label: "河北省" },
    { value: "山西省", label: "山西省" },
    { value: "辽宁省", label: "辽宁省" },
    { value: "吉林省", label: "吉林省" },
    { value: "黑龙江省", label: "黑龙江省" },
    { value: "江苏省", label: "江苏省" },
    { value: "浙江省", label: "浙江省" },
    { value: "安徽省", label: "安徽省" },
    { value: "福建省", label: "福建省" },
    { value: "江西省", label: "江西省" },
    { value: "山东省", label: "山东省" },
    { value: "河南省", label: "河南省" },
    { value: "湖北省", label: "湖北省" },
    { value: "湖南省", label: "湖南省" },
    { value: "广东省", label: "广东省" },
    { value: "海南省", label: "海南省" },
    { value: "四川省", label: "四川省" },
    { value: "贵州省", label: "贵州省" },
    { value: "云南省", label: "云南省" },
    { value: "陕西省", label: "陕西省" },
    { value: "甘肃省", label: "甘肃省" },
    { value: "青海省", label: "青海省" },
    // { value: '台湾省', label: '台湾省' }, // 注意：实际情况中，这里可能需要特殊处理或敏感处理
    { value: "内蒙古自治区", label: "内蒙古自治区" },
    { value: "广西壮族自治区", label: "广西壮族自治区" },
    { value: "西藏自治区", label: "西藏自治区" },
    { value: "宁夏回族自治区", label: "宁夏回族自治区" },
    { value: "新疆维吾尔自治区", label: "新疆维吾尔自治区" },
    { value: "香港特别行政区", label: "香港特别行政区" },
    { value: "澳门特别行政区", label: "澳门特别行政区" },
  ];
  const getLabel = (v) => {
    let lab = v.useScene;
    let b = [
      { key: "1", value: "AI绘画" },
      { key: "2", value: "科学计算" },
      { key: "3", value: "渲染" },
      { key: "4", value: "模型推理" },
      { key: "5", value: "模型训练" },
    ];
    const keysArray = lab.split(",");
    const filteredArray = b.filter((item) => keysArray.includes(item.key));
    return filteredArray.map((v) => {
      return (
        <span className={`lab_${v.key}`} key={v.key}>
          {v.value}
        </span>
      );
    });
  };
  const changeAre = (v) => {
    setArea(v);
  };
  // const toDetail = (record) => {
  //   navigate("/computa_detail", {
  //     state: {
  //       id: record.computPowerId,
  //       profilePictureUrl: record.profilePictureUrl,
  //       nickName: record.nickName,
  //     },
  //   });
  // };
  const toDetail = (record) => {
    // 构建 URL 参数
    const params = new URLSearchParams({
      id: record.computPowerId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    const url = `/computa_detail?${params.toString()}`;
    window.open(url, "_blank"); // 在新窗口或新标签页中打开
  };
  const debouncedFetchData = _.debounce(getCompute, 1000);
  const handleChange = (e) => {
    debouncedFetchData(e.target.value);
  };
  return (
    <Layout className="suanlist">
      <Header className="suanlist-hea">
        <div className="name">算力交易</div>
        <Input
          placeholder="搜索"
          style={{ width: "300px", marginTop: "16px" }}
          onChange={handleChange}
        />
      </Header>
      <Content className="suan-cont">
        <Collapse activeKey={activeKey} onChange={setActiveKey}>
          <div className="collapse-panel">
            <div className="collapse-header">
              <div className="name">适用场景</div>
              <div direction="vertical" className="chuzsz">
                {neitagOptions}
              </div>
              <button onClick={toggleExpansion} className="toggle-button">
                {isExpanded ? <DownCircleTwoTone /> : <UpCircleTwoTone />}
              </button>
            </div>
            {isExpanded && (
              <div className="collapse-content">
                <div className="cont-shai">
                  <div className="name">显存（GB）</div>
                  <div direction="vertical" className="chuzsz">
                    {xctagOptions}
                  </div>
                </div>
                <div className="cont-shai">
                  <div className="name">所在地区</div>
                  <div direction="vertical" className="chuzsz">
                    <Select
                      placeholder="请选择省份"
                      style={{ width: "150px" }}
                      onChange={changeAre}
                    >
                      {allProvinces.map((province) => (
                        <Select.Option
                          key={province.value}
                          value={province.value}
                        >
                          {province.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>
                {/* 其他筛选选项 */}
                <div className="cont-shai">
                  <div className="name">系统环境</div>
                  <div direction="vertical" className="chuzsz">
                    {xttagOptions}
                  </div>
                </div>
                <div className="cont-shai">
                  <div className="name">存储空间（GB）</div>
                  <div direction="vertical" className="chuzsz">
                    {cctagOptions}
                  </div>
                </div>
                <div className="cont-shai">
                  <div className="name">CPU（核(vCPU)）</div>
                  <div direction="vertical" className="chuzsz">
                    {cputagOptions}
                  </div>
                </div>
                <div className="cont-shai">
                  <div className="name">内存（GiB）</div>
                  <div direction="vertical" className="chuzsz">
                    {neictagOptions}
                  </div>
                </div>
                <div className="cont-shai">
                  <div className="name">网络带宽（Mbps）</div>
                  <div direction="vertical" className="chuzsz">
                    {dktagOptions}
                  </div>
                </div>
              </div>
            )}
          </div>
        </Collapse>
      </Content>
      <div className="soujg">
        <div>默认排序</div>
        <div className="pice">
          价格：
          <InputNumber
            placeholder="请输入最低价格"
            min={0}
            value={priceRange.minPrice}
            onChange={(value) => handlePriceChange("minPrice", value)}
          />
          -
          <InputNumber
            placeholder="请输入最高价格"
            min={0}
            value={priceRange.maxPrice}
            onChange={(value) => handlePriceChange("maxPrice", value)}
          />
          <Button type="primary" onClick={search}>
            搜索
          </Button>
        </div>
      </div>
      <Footer className="suan-foot">
        {computeData.map((v) => (
          <div className="cont_sanx" key={v.id}>
            <div className="cont-l">
              <div className="title" onClick={() => toDetail(v)}>
                {v.gpu} {v.systemEnvironment}
              </div>
              <div>
                <span className="xinx">
                  CPU {cpus.find((item) => item.key === v.cpu).value}
                </span>
                <span className="xinx">
                  内存
                  {v.memory
                    ? neics.find((item) => item.key === v.memory).value
                    : ""}
                </span>
                <span className="xinx">存储空间 {v.space}GB</span>
              </div>
              <div className="lable_name">
                <div className="zhuangt">{getLabel(v)}</div>
                <div className="txname">
                  <img
                    src={`/file/${v.profilePictureUrl}`}
                    alt=""
                    className="tx"
                  />
                  {v.nickName || tool.hideMiddleFour(v.phone)}
                </div>
              </div>
            </div>
            <div className="cont-r">
              <div>
                <span className="xinx">
                  出租时长： {v.hireTime}
                  {v.hireType === 1 ? "天" : v.hireType === 2 ? "月" : "年"}
                </span>
              </div>
              <div>
                <div className="mone">
                  ￥ {v.hirePrice} 元 /{" "}
                  {v.hireType === 1 ? "天" : v.hireType === 2 ? "月" : "年"}
                </div>
                <div className="leng" onClick={() => toDetail(v)}>
                  了解更多
                </div>
              </div>
            </div>
          </div>
        ))}
      </Footer>
    </Layout>
  );
};

export default HashrateManagement;
